(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wayborne-size-link"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
 const link=event.target.closest('[data-ws-size-guide]');if(!link)return;
 const target=link.getAttribute('href');if(!target||target.charAt(0)!=='#')return;
 const guide=document.getElementById(target.slice(1));if(!guide)return;
 const details=guide.closest('details');if(details)details.open=true;
 guide.setAttribute('tabindex','-1');guide.focus({preventScroll:true});
});
  } catch(e) { console.error(e); }
})();

})();
